module.exports = __webpack_public_path__ + "img/lock.93d82e56.svg";